import SelectedLabFacility from './SelectedLabFacility'

export default SelectedLabFacility
